import { RefObject, useCallback, useEffect, useState } from 'react';

export const useFullScreen = (ref: RefObject<HTMLDivElement & any>) => {
  const [fullScreen, setFullScreen] = useState(false);
  const hasFullscreen = !!(ref.current?.requestFullscreen || ref.current?.webkitRequestFullscreen);

  useEffect(() => {
    const handler = (e: any) => {
      // @ts-ignore
      if (document.fullscreenElement || document.webkitFullscreenElement) {
        setFullScreen(true);
      } else {
        setFullScreen(false);
      }
    }
    const reference = ref.current;
    if (reference) {
      reference.addEventListener('fullscreenchange', handler);
      reference.addEventListener('webkitfullscreenchange', handler);

      return () => {
        reference.removeEventListener('fullscreenchange', handler);
        reference.removeEventListener('webkitfullscreenchange', handler);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleExitFullScreen = () => {
    // Check if document is actually in fullscreen mode before attempting to exit
    // @ts-ignore
    const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement;
    
    if (isFullscreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        // @ts-ignore
      } else if (document.webkitExitFullscreen) {
        // @ts-ignore
        document.webkitExitFullscreen();
      }
    }
    setFullScreen(false);
  };

  const handleOpenFullScreen = () => {
    if (ref.current?.requestFullscreen || ref.current?.webkitRequestFullscreen) {
      if (ref.current?.requestFullscreen) {
        ref.current?.requestFullscreen();
      } else if (ref.current?.webkitRequestFullscreen) {
        ref.current.webkitRequestFullscreen();
      }
      setFullScreen(true);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const close = useCallback(handleExitFullScreen, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const open = useCallback(handleOpenFullScreen, []);

  return {
    close,
    open,
    hasFullscreen,
    fullScreen
  };
}
